import { render, staticRenderFns } from "./HsCodeINPop.vue?vue&type=template&id=9a46f454"
import script from "./HsCodeINPop.vue?vue&type=script&lang=js"
export * from "./HsCodeINPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a46f454')) {
      api.createRecord('9a46f454', component.options)
    } else {
      api.reload('9a46f454', component.options)
    }
    module.hot.accept("./HsCodeINPop.vue?vue&type=template&id=9a46f454", function () {
      api.rerender('9a46f454', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/HsCodeINPop.vue"
export default component.exports